import React from 'react'
import { Modal } from 'react-bootstrap'
// Estilo `.delivery-alert-modal` é global (definido em SelectProducts/index.css, SMME26-78);
// aplicado via dialogClassName abaixo.

/**
 * SMME26-42 — Modal "CEP não atendido" (restrição de entrega domiciliar dos Correios).
 * Bloqueante: o cliente precisa informar outro CEP atendido para prosseguir.
 * "Alterar endereço" apenas fecha o modal (deixa o cliente corrigir o CEP) — sem efeitos
 * colaterais de limpar storage/redirecionar.
 */
export const CepNotDeliverableModal = ({ show, onClose }) => (
  <Modal show={show} dialogClassName="delivery-alert-modal">
    <Modal.Body>
      <div className="modalHeader">
        <span className="icon-alert" />
        <h1>CEP não atendido</h1>
      </div>
      <div className="modalContent">
        <p>
          Infelizmente a transportadora <strong>não realiza entregas</strong> para o CEP informado.
        </p>
        <div className="delivery-card">
          Para continuar com sua compra, informe um endereço de entrega em uma área atendida pela
          transportadora.
        </div>
        <p className="delivery-note">Em caso de dúvidas, entre em contato com o nosso suporte.</p>
      </div>
      <div className="modalFooter">
        <button className="modal-close inline-button accept" onClick={onClose}>
          Alterar endereço
        </button>
      </div>
    </Modal.Body>
  </Modal>
)

/**
 * SMME26-42 (D2 / opção C) — quando NÃO foi possível calcular o frete (falha total do cálculo
 * ou timeout), não deixamos seguir sem frete: pedimos para tentar novamente. Diferente da
 * restrição de CEP: aqui não é "área não atendida", é indisponibilidade momentânea.
 */
export const FreightUnavailableModal = ({ show, onClose }) => (
  <Modal show={show} dialogClassName="delivery-alert-modal">
    <Modal.Body>
      <div className="modalHeader">
        <span className="icon-alert" />
        <h1>Não foi possível calcular o frete</h1>
      </div>
      <div className="modalContent">
        <p>Tivemos um problema ao calcular o frete para o CEP informado.</p>
        <p className="delivery-note">Por favor, tente novamente em instantes.</p>
      </div>
      <div className="modalFooter">
        <button className="modal-close inline-button accept" onClick={onClose}>
          Tentar novamente
        </button>
      </div>
    </Modal.Body>
  </Modal>
)
